(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule', [
			'apiModule',
			'agreementsModule',
			'amountSelectModule',
			'coreModule',
			'fileUploadModule',
			'formValidationModule',
			'googleRecaptchaModule',
			'localStorageModule',
			'ngFileUpload',
			'ngMessages',
			'optionsModule',
			'plaidModule',
			'planVariantSelectModule',
			'progressIndicatorModule',
			'ui.mask',
			'optionsModule',
			'vcRecaptcha',
			'viewPlanModule'
		])
		.constant('BANK_ACCOUNT_TYPE_OPTIONS', [
			{ value: 'CHECKING', label: 'Checking'},
			{ value: 'SAVINGS', label: 'Savings'}
		])
		.value('globalConfig', globalConfig);
})(window.angular);